import script from "./AccordionQueries.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionQueries.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionQueries.vue?vue&type=style&index=0&id=72b1bc7e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b1bc7e"]])

export default __exports__